import { h, Component } from 'preact';
import { joinClasses, sortObjectByOrder } from 'utils/utils';
import tks from 'base/boltToolkit/boltToolkitApp.sss';
import s from 'base/boltToolkit/campaignGenerator.sss';
import copy from 'copy-to-clipboard';

function findRootPage(pages) {
	const rootPage = pages.find(page => page.path === '/');

	return rootPage;
}

export default class CampaignGenerator extends Component {
	constructor(props) {
		super(props);

		this.state = {
			campaignName: '',
			campaignSource: '',
			campaignMedium: '',
			landingPage: findRootPage(this.props.pages),
			copied: false,
			allRequiredFieldsFilled: false
		};

		this.updateResult = this.updateResult.bind(this);
	}

	componentWillUnmount() {
		window.clearTimeout(this.copyTimeout);
	}

	updateResult(e) {
		let newValue = e.target.value;
		if (e.target.name === 'landingPage') {
			newValue = this.props.pages.find(page => page.path === e.target.value);
		}
		let updatedValue = {};
		updatedValue[e.target.name] = newValue;

		this.setState(updatedValue);
	}

	generateResult(appUrl) {
		try {
			const { landingPage, campaignSource, campaignName, campaignMedium } = this.state;

			const base = appUrl + '/';
			const relativePath = landingPage?.path || '/';
			const url = new URL('.' + relativePath, base);

			if (campaignSource) {
				url.searchParams.set('utm_source', campaignSource);
			}
			if (campaignName) {
				url.searchParams.set('utm_campaign', campaignName);
			}
			if (campaignMedium) {
				url.searchParams.set('utm_medium', campaignMedium);
			}

			return url.toString();
		} catch (e) {
			return appUrl;
		}
	}

	render({ data = {}, pages, appUrl }, { landingPage = {}, copied, campaignSource, campaignMedium, campaignName }) {
		const { title, fields, ctas } = data;

		const result = this.generateResult(appUrl);
		let allRequiredFieldsFilled = !!campaignSource && !!campaignMedium && !!campaignName;

		return (
			<form class={s.generator} onSubmit={e => e.preventDefault()}>
				<div class={s.container}>
					<h2 class={joinClasses(tks.h2, s.title)}>{title}</h2>
					<div class={s.fields}>
						{sortObjectByOrder(fields).map(field => {
							const { id, label, placeholder } = field;

							let input = <input class={joinClasses(tks.p, tks.bold, s.input)} name={id} placeholder={placeholder} onInput={this.updateResult} />;

							if (id === 'landingPage') {
								input = (
									<div class={joinClasses(tks.p, tks.bold, s.input, s.dropdown)}>
										<select ref={ref => this.pageSelect = ref} class={s.select} name={id} onChange={this.updateResult}>
											{pages.map(page => (
												<option selected={page.path === '/' ? 'selected' : false} value={page.path}>{this.props.copy[page.name] || page.name}</option>
											))}
										</select>
										<div class={s.fakeSelect}>
											{this.props.copy[landingPage.name] || landingPage.name}
										</div>
									</div>
								);
							}

							return (
								<label class={s.field}>
									<div class={joinClasses(tks.bold, tks.p, s.label, (id !== 'landingPage') && s.required)}>{label}</div>
									{input}
								</label>
							);
						})}
					</div>
					{!allRequiredFieldsFilled && <div class={s.warning}>Fill out all the required fields above and a tagged URL will be automatically generated for you below.</div>}
					<input class={joinClasses(tks.p, s.result, tks.bold)} readonly value={result} />
					<div class={s.ctas}>
						{sortObjectByOrder(ctas).map(cta => {
							const trigger = () => {
								if (cta.type === 'visit') {
									window.open(result);
								} else if (cta.type === 'copy') {
									copy(result);
									this.setState({ copied: true });
									this.copyTimeout = window.setTimeout(() => {
										this.setState({ copied: false });
									}, 3000);
								}
							};

							let label = cta.name;
							if (copied && cta.type === 'copy') {
								label = <div class={s.copyIcon} />;
							}

							return (
								<button onClick={trigger} class={joinClasses(s.cta, tks.bold, tks.p, s[cta.type], copied && s.copied)}>
									{label}
								</button>
							);
						})}
					</div>
				</div>
			</form>
		);
	}
}
